export default __webpack_public_path__ + "static/media/users_4.da49ea29.png";